import {
  extractViaLlmPipeline,
  isLlmExtractionEnabled,
} from "../services/ocr/llm";

/**
 * Run OCR for any personal document type.
 * Returns only raw_text, cleaned_text, extracted_json (single JSON with all keys).
 */
export const extractPersonalDocumentFromFile = async (
  file,
  documentType,
  onProgress,
  options = {},
) => {
  if (!isLlmExtractionEnabled()) {
    throw new Error(
      "LLM document extraction is disabled. Set REACT_APP_OCR_USE_LLM=true or enable FORCE_LLM_EXTRACTION in llmExtractionConfig.js.",
    );
  }

  console.info("[LLM] Using async LLM pipeline for", documentType);
  return extractViaLlmPipeline(file, documentType, onProgress, options);
};
